import { useRef, useEffect, useCallback } from 'react';

/**
 * Evita que uma resposta de API atrasada (ou chegando depois que o
 * componente desmontou) sobrescreva estado mais recente - necessário
 * nas telas com paginação/busca, onde trocar de página e digitar uma
 * busca em sequência rápida dispara mais de um fetch, e a rede não
 * garante a ordem de chegada das respostas.
 */
export default function useRequestGuard() {
    const requestIdRef = useRef(0);
    const isMountedRef = useRef(true);

    useEffect(
        () => () => {
            isMountedRef.current = false;
        },
        []
    );

    const start = useCallback(() => ++requestIdRef.current, []);
    const isCurrent = useCallback((id) => isMountedRef.current && requestIdRef.current === id, []);

    return { start, isCurrent };
}
